<script>
    import { _ } from "svelte-i18n";

    export let audioInfo;

    /* import { createEventDispatcher } from "svelte";
    const dispatch = createEventDispatcher(); */
</script>

<main style="height: 100%;">
    <div class="margin-top">
        <span style="font-weight: 400;" class="headline-xs">
            {$_("room")}
            {audioInfo.room}
        </span>
    </div>
    <div class="title headline-l">{audioInfo.title}</div>
    <div class="headline-m subtitle" style="opacity: 40%">
        {audioInfo.subtitle}
    </div>
    <div>
        {#each audioInfo.sections ?? [] as section, index}
            {@html section.content ?? ""}
        {/each}
    </div>
    <div>
        {#if audioInfo.additionalInfo}
            <div class="additional-info">
                {@html audioInfo.additionalInfo}
            </div>
        {/if}

        <div class="seperator" />
        <div class="details">
            <h2>{$_("guide_details")}</h2>
            <div class="details-info">
                {#if audioInfo.medium}
                    <span class="details-title"> {$_("guide_medium")} </span>
                    <span class="details-content">
                        {audioInfo.medium}
                    </span>
                {/if}
                {#if audioInfo.dimensions}
                    <span class="details-title"> {$_("guide_size")} </span>
                    <span class="details-content">
                        {audioInfo.dimensions}
                    </span>
                {/if}
            </div>
        </div>
    </div>
</main>

<style>
    .subtitle {
        font-size: 40px;
        font-weight: 400;
        opacity: 40%;
        margin-bottom: 32px;
    }

    .title {
        margin-top: 8px;
        font-weight: 400;
    }

    .seperator {
        height: 1px;
        width: 100%;
        background-color: #000;
        margin: 40px 0 16px;
    }

    .additional-info {
        opacity: 40%;
        font-size: 12px;
        line-height: 20.4px;
        margin: 32px 0;
    }

    .details-info {
        display: grid;
        grid-template-columns: 0.5fr 1fr;
        grid-row-gap: 8px;
        font-size: 16px;
        font-weight: 400;
    }

    .details-title {
        opacity: 40%;
    }

    .margin-top {
        margin-top: 100px;
    }

    @media (min-width: 1440px) {
        .margin-top {
            margin-top: 32px;
        }
    }
</style>
